import { useMemo } from 'react';
import { type Nullable } from '@direct-frontend/stdlib';
import { VariantInfoDisplayTypes, type VariantsInfo } from '@/shared/api/variants';

export const useCurrentVariants = (currentVariants: Nullable<VariantsInfo>) => {
    const sizeTableSrc = useMemo(() => {
        if (currentVariants?.size_table && currentVariants.size_table.enabled && currentVariants.size_table.file_path) {
            return currentVariants.size_table.file_path;
        }

        return;
    }, [currentVariants]);

    const variantsInfo = useMemo(() => {
        if (currentVariants && currentVariants.variants_info) {
            return currentVariants.variants_info.map((variant) => {
                /**
                 * Не выводим селекты в модалке/drawer-e. Заменяем на вывод через теги
                 */
                return {
                    ...variant,
                    display_type:
                        variant.display_type === VariantInfoDisplayTypes.SELECT
                            ? VariantInfoDisplayTypes.TEXT
                            : variant.display_type,
                };
            });
        }

        return [];
    }, [currentVariants]);

    const newVariantId = currentVariants?.new_variant_id;

    return {
        sizeTableSrc,
        variantsInfo,
        newVariantId,
    };
};
